import firebase from 'firebase';
import { signInWithEmail, signOut, getUserConfig, sendPasswordResetEmail, signInAnonymously, signInWithGoogle } from '../../api/authentication';
import errorCodeToMessage from '../../helpers/firebase';
import { normalizeConfig } from '../../helpers/config';
import { initialise, deleteApp } from '../../firebase';

const storageDb = firebase.initializeApp({
  apiKey: 'AIzaSyAzQEBjw9rul7LW14kt_wJlG2QbOJuBydY',
  authDomain: 'storage-7ecd6.firebaseapp.com',
  databaseURL: 'https://storage-7ecd6.firebaseio.com',
  projectId: 'storage-7ecd6',
  storageBucket: 'storage-7ecd6.appspot.com',
  messagingSenderId: '73859705508',
}, 'STORAGE');


const authentication = {
  state: {
    message: '',
    logos: [],
    messageType: 'error',
    isAuthRequested: false,
    isAuthenticated: false,
    isAuthenticating: false,
    isAuthFailed: false,
    isAnonymousAuthenticating: false,
    sendingPasswordResetLink: false,
    getConfigUrl: 'https://qx0nowybrl.execute-api.us-east-1.amazonaws.com/development/getConfiguration',
  },

  getters: {
    authenticated: state => state.isAuthenticated,
    authRequested: state => state.isAuthRequested,
    authFailed: state => state.isAuthFailed,
  },

  mutations: {
    IS_AUTHENTICATING(state, payload) {
      state.isAuthenticating = payload;
    },

    IS_ANONYMOUS_AUTHENTICATING(state, payload) {
      state.isAnonymousAuthenticating = payload;
    },

    AUTH_REQUESTED(state) {
      state.isAuthRequested = true;
    },

    AUTH_SUCCESS(state) {
      state.isAuthenticated = true;
      state.isAuthenticating = false;
      state.isAnonymousAuthenticating = false;
    },

    AUTH_FAILED(state, payload) {
      let errorMessage = errorCodeToMessage(payload);
      if (!errorMessage) errorMessage = 'User not found.';
      state.message = errorMessage;
      state.isAuthFailed = true;
      state.isAuthenticating = false;
    },

    CLEAR_MESSAGE(state) {
      state.message = '';
      state.messageType = 'error';
    },

    SENDING_PASS_RESET_LINK(state, payload) {
      state.sendingPasswordResetLink = payload;
    },

    PASSWORD_RESET_LINK_SENT(state) {
      state.sendingPasswordResetLink = false;
      state.message = 'Reset link has been sent to your registered email.';
    },

    LOGOS_FETCHED(state, payload) {
      state.logos = payload;
    },
  },

  actions: {
    async fetchConfig({ state }, payload) {
      const config = await getUserConfig(payload.env, payload.client);
      return config;
    },

    logout({ state }) {
      signOut().then(() => {
        state.isAuthenticated = false;
      });
    },

    fetchLogo(context) {
      storageDb.database().ref('logos').once('value').then((snapshot) => {
        context.commit('LOGOS_FETCHED', snapshot.val());
      });
    },

    async sendResetLink({ state, commit, rootState }, username) {
      state.message = '';
      commit('SENDING_PASS_RESET_LINK', true);
      try {
        const env = rootState.appGlobal.env;
        const config = await getUserConfig(env, username);
        const normalized = normalizeConfig(config.data);
        const email = config.data && config.data.firebase_email_id;
        initialise(normalized);
        sendPasswordResetEmail(email)
          .then(() => {
            deleteApp().then(() => {
              state.messageType = 'success';
              commit('PASSWORD_RESET_LINK_SENT');
            });
          })
          .catch((error) => {
            deleteApp().then(() => {
              commit('SENDING_PASS_RESET_LINK', false);
              commit('AUTH_FAILED', error);
            });
          });
      } catch (error) {
        commit('SENDING_PASS_RESET_LINK', false);
        commit('AUTH_FAILED', error);
      }
    },

    async authenticate({ state, commit, rootState }, { username, password }) {
      state.message = '';
      const hostname = window.location.hostname.split('.')[0];
      let config;
      let email;
      commit('IS_AUTHENTICATING', true);
      try {
        const env = rootState.appGlobal.env;
        console.log(hostname !== 'insideinsight');
        if (hostname !== 'insideinsight') {
          config = await getUserConfig(env, hostname);
          email = username;
        } else {
          config = await getUserConfig(env, username);
          email = config.data && config.data.firebase_email_id;
        }
        const normalized = normalizeConfig(config.data);
        if (!email) throw Error('User not found');
        initialise(normalized);
        signInWithEmail(email, password)
          .then((user) => {
            localStorage.setItem(env, JSON.stringify(config.data));
            localStorage.setItem('firebase_email_id', email);
            localStorage.setItem('uid', user.uid);
            commit('SAVE_USER', user);
            commit('AUTH_SUCCESS');
            commit('CLEAR_MESSAGE');
          })
          .catch((error) => {
            deleteApp().then(() => {
              localStorage.clear();
              commit('IS_AUTHENTICATING', false);
              commit('AUTH_FAILED', error);
            });
          });
      } catch (error) {
        localStorage.clear();
        commit('IS_AUTHENTICATING', false);
        commit('AUTH_FAILED', error);
      }
    },
    async anonymousAuthenticate({ state, commit, rootState }) {
      state.message = '';
      commit('IS_ANONYMOUS_AUTHENTICATING', true);
      try {
        const env = rootState.appGlobal.env;
        const config = await getUserConfig(env, window.location.hostname.split('.')[0]);
        const normalized = normalizeConfig(config.data);
        // console.log(config);
        initialise(normalized);
        signInAnonymously()
          .then((user) => {
            console.log(user.uid);
            localStorage.setItem(env, JSON.stringify(config.data));
            localStorage.setItem('uid', user.uid);
            localStorage.setItem('is_anonymous_login', true);
            firebase.database().ref(`Users/${user.uid}`).set({
              isAnonymousLogin: true,
            });
            commit('SAVE_USER', user);
            commit('AUTH_SUCCESS');
            commit('CLEAR_MESSAGE');
          })
          .catch((error) => {
            deleteApp().then(() => {
              localStorage.clear();
              commit('IS_ANONYMOUS_AUTHENTICATING', false);
              commit('AUTH_FAILED', error);
            });
          });
      } catch (error) {
        localStorage.clear();
        commit('IS_ANONYMOUS_AUTHENTICATING', false);
        commit('AUTH_FAILED', error);
      }
    },
    async googleAuthenticate({ state, commit, rootState }) {
      state.message = '';
      try {
        const env = rootState.appGlobal.env;
        const config = await getUserConfig(env, window.location.hostname.split('.')[0]);
        const normalized = normalizeConfig(config.data);
        // console.log(config);
        initialise(normalized);
        signInWithGoogle()
          .then((response) => {
            localStorage.setItem(env, JSON.stringify(config.data));
            localStorage.setItem('uid', response.user.uid);
            localStorage.setItem('is_anonymous_login', true);
            firebase.database().ref(`Users/${response.user.uid}`).set({
              email: response.user.email,
              firstName: response.user.displayName,
              lastName: '',
              organisation: 'IA',
            });
            commit('SAVE_USER', response.user);
            commit('AUTH_SUCCESS');
            commit('CLEAR_MESSAGE');
          })
          .catch((error) => {
            deleteApp().then(() => {
              localStorage.clear();
              commit('AUTH_FAILED', error);
            });
          });
      } catch (error) {
        localStorage.clear();
        commit('AUTH_FAILED', error);
      }
    },
  },
};

export default authentication;



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js